module.exports = __webpack_public_path__ + "static/img/kols_banner.f7c2582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols_banner.png
// module id = 7+zE
// module chunks = 0